import { combineReducers } from 'redux';
import { DEFAULT_TAB_ITEM_ID } from '../utils/packagesUtils/constants';
import packagesReducer from './packages';
import packagesTabsReducer from './packagesTabs';
import ugcReducer from './ugc';
import collectionsReducer from './collections';
import sellerReducer from './seller';

export default ({ packages, studio, general, ugcMap }) => {
    const { isStudio } = general;
    let tabItems = [{ id: DEFAULT_TAB_ITEM_ID, name: 'gig_page_perseus.general.whats_included' }];

    if (isStudio) {
        tabItems = studio.services;
    }

    return combineReducers({
        packages: packagesReducer({ packages, general }),
        packagesTabs: packagesTabsReducer(tabItems),
        ugc: ugcReducer(ugcMap),
        collections: collectionsReducer(),
        seller: sellerReducer()
    });
};
